module.exports = __webpack_public_path__ + "ye.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ye.svg
// module id = 891
// module chunks = 0